if (!customElements.get('save-percent-property')) {
  class SavePercentProperty extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-save-percent-input]');
      this.sectionId = this.dataset.sectionId;

      this.unsubscribe = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        (event) => this.onVariantChange(event)
      );
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }

    onVariantChange(event) {
      const { sectionId, variant } = event?.data ?? {};
      if (String(sectionId) !== String(this.sectionId)) return;

      const compareAt = variant?.compare_at_price;
      const price = variant?.price;

      if (!compareAt || !price || compareAt <= price) {
        this.setValue('');
        return;
      }

      const percent = Math.floor(((compareAt - price) * 100) / compareAt);
      this.setValue(`${percent}% (was ${this.formatMoney(compareAt)})`);
    }

    formatMoney(cents) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat).replace(/<[^>]*>/g, '');
    }

    setValue(value) {
      if (!this.input) return;

      if (value) {
        this.input.value = value;
        this.input.disabled = false;
      } else {
        this.input.value = '';
        this.input.disabled = true;
      }
    }
  }

  customElements.define('save-percent-property', SavePercentProperty);
}
